import { fadeIn, fadeOut } from './helpers';

export default class Popup {
    constructor() {
        this.body = window.document.querySelector('body');
        this.html = window.document.querySelector('html');
        this.redirectPopup = null;
        this.redirectHandler = null;
    }

    /**
     * Force Close All opened popup window
     * and clear the traces of an opened popup window
     */
    forceCloseAllPopup() {
        [...window.document.querySelectorAll('.popup')].forEach((item) => {
            const allErrorsInPopup = item.querySelectorAll(
                '.wpcf7-not-valid-tip'
            );
            const bottomMessage = item.querySelectorAll(
                '.wpcf7-response-output'
            );
            const form = item.querySelectorAll('form'); // reset()

            if (allErrorsInPopup) {
                // eslint-disable-next-line no-shadow
                allErrorsInPopup.forEach((item) => {
                    item.remove();
                });
            }

            if (bottomMessage) {
                // eslint-disable-next-line no-shadow
                bottomMessage.forEach((item) => {
                    item.remove();
                });
            }

            if (form) {
                // eslint-disable-next-line no-shadow
                form.forEach((item) => {
                    item.reset();
                });
            }

            this.cleanFormData(item);

            fadeOut(item);
            const MAIL_SENT_OK_BOX = item.querySelector('.wpcf7-mail-sent-ok');
            if (MAIL_SENT_OK_BOX) {
                MAIL_SENT_OK_BOX.style.display = 'none';
            }
        });

        this.removeRedirect();

        this.body.classList.remove('popup-opened');
        this.html.classList.remove('popup-opened');
    }

    /**
     * Open selected popup window
     *
     * @param {string} popupSelector - css selector of popup that should be opened
     * @param {number} timeOut - ms
     */
    openOnePopup(popupSelector = null, timeOut = 1000) {
        this.forceCloseAllPopup();

        setTimeout(() => {
            this.body.classList.add('popup-opened');
            this.html.classList.add('popup-opened');
            fadeIn(popupSelector);
        }, timeOut);
    }

    /**
     * Opening popup window
     */
    openPopup() {
        this.body.addEventListener('click', (event) => {
            if (
                ![...event.target.classList].includes('js-open-popup-activator')
            ) {
                return false;
            }

            event.preventDefault();
            const elHref =
                event.target.nodeName === 'A'
                    ? event.target.getAttribute('href')
                    : event.target.dataset.href;

            this.fillFormData(event.target, elHref);
            this.setRedirect(event.target, elHref);

            this.body.classList.add('popup-opened');
            // this.html.classList.add('popup-opened');
            fadeIn(elHref);
            return true;
        });
    }

    /**
     * Fill popup form hidden fields from data-form-* attributes of the activator
     *
     * @param {HTMLElement} activator - clicked element that opens the popup
     * @param {string} popupSelector - css selector of the popup
     */
    fillFormData(activator, popupSelector) {
        if (!popupSelector || !popupSelector.startsWith('#')) {
            return;
        }

        const popup = window.document.querySelector(popupSelector);
        const form = popup ? popup.querySelector('form') : null;

        if (!form) {
            return;
        }

        form.querySelectorAll('input.wpcf7-hidden').forEach((input) => {
            const key = 'form' + input.name
                .split('-')
                .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
                .join('');
            input.value = activator.dataset[key] || '';

            popup.querySelectorAll('.js-fill-' + input.name).forEach((el) => {
                el.textContent = input.value;
            });
        });
    }

    /**
     * Clear popup form hidden fields filled by fillFormData
     *
     * @param {HTMLElement} popup - popup element
     */
    cleanFormData(popup) {
        const form = popup ? popup.querySelector('form') : null;

        if (!form) {
            return;
        }

        form.querySelectorAll('input.wpcf7-hidden').forEach((input) => {
            input.value = '';

            popup.querySelectorAll('.js-fill-' + input.name).forEach((el) => {
                el.textContent = '';
            });
        });
    }

    /**
     * Redirect to activator data-redirect-url after successful submit of the popup form
     *
     * @param {HTMLElement} activator - clicked element that opens the popup
     * @param {string} popupSelector - css selector of the popup
     */
    setRedirect(activator, popupSelector) {
        const redirectUrl = activator.dataset.redirectUrl;

        if (!redirectUrl || !popupSelector) {
            return;
        }

        const popup = window.document.querySelector(popupSelector);

        if (!popup || !popup.querySelector('form')) {
            return;
        }

        this.removeRedirect();

        this.redirectPopup = popup;
        this.redirectHandler = () => {
            window.location.href = redirectUrl;
        };

        popup.addEventListener('wpcf7mailsent', this.redirectHandler);
    }

    /**
     * Remove redirect handler added by setRedirect
     */
    removeRedirect() {
        if (this.redirectPopup && this.redirectHandler) {
            this.redirectPopup.removeEventListener('wpcf7mailsent', this.redirectHandler);
        }

        this.redirectPopup = null;
        this.redirectHandler = null;
    }

    /**
     * Closing popup window
     */
    closePopup() {
        this.body.addEventListener('click', (event) => {
            // Check if user click on close element
            if (![...event.target.classList].includes('js-popup-close')) {
                return false;
            }
            const popupLockPost = document.querySelectorAll('.js-popup-form');

            popupLockPost &&
                popupLockPost.forEach((popup) => {
                    popup.classList.remove('sent');
                });

            event.preventDefault();
            this.forceCloseAllPopup();
            return true;
        });

        // Checking ESC button for closing opened popup window
        window.document.addEventListener('keydown', (event) => {
            if (event.keyCode === 27) {
                this.forceCloseAllPopup();
            }
        });
    }

    init() {
        this.openPopup();
        this.closePopup();
    }
}
